import { render } from "./ExhibitionEvent.vue?vue&type=template&id=1ccb80f4&scoped=true"
import script from "./ExhibitionEvent.vue?vue&type=script&lang=js"
export * from "./ExhibitionEvent.vue?vue&type=script&lang=js"

import "./ExhibitionEvent.vue?vue&type=style&index=0&id=1ccb80f4&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccb80f4"]])

export default __exports__